import { render } from "./MarkupView.vue?vue&type=template&id=5c2a806d&scoped=true"
import script from "./MarkupView.vue?vue&type=script&lang=js"
export * from "./MarkupView.vue?vue&type=script&lang=js"

import "./MarkupView.vue?vue&type=style&index=0&id=5c2a806d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2a806d"]])

export default __exports__